<div class="detail-parent-card gap-3">
  <span class="detail-card-title" i18n>Withdrawal Instructions</span>
  <div class="card-subtext" i18n>The payments will be made with the withdrawal percentages outlined below</div>
  <div class="funds-grid">
    <div
      *ngFor="let instruction of withdrawalInstructions; trackBy: trackByIndex"
      class="fund-card inner-card d-flex flex-column gap-2">
      <div class="fund-indicator" aria-hidden="true" [style.background-color]="instruction.fund?.colour"></div>
      <div class="label-md">{{ instruction.fund?.name }}</div>
      <div class="paragraph-lg">{{ instruction.percentage | number : '1.2-2' }}%</div>
    </div>
  </div>
</div>
